import { ReactNode, useEffect } from 'react';
import { ApiError } from '@/services/api';
import { ModalSize, useModal } from '@fs/uikit-react';
import { Person } from '../types/person.ts';
import { PersonApi } from '../api/PersonApi.ts';

export let refreshPersons = () => {};
export let openModal: ((size: ModalSize, title: string, content: ReactNode) => void);

export const useInit = (
  setPersons: (value: Person[]) => void,
  setLoading: (value: boolean) => void,
  setError: (value: ApiError | null) => void
) => {
  openModal = useModal().openModal;

  useEffect(() => {
    refreshPersons = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await PersonApi.getAll();
        setPersons(response.data as Person[]);
      } catch (err) {
        setError(err as ApiError);
        console.error('Error fetching persons:', err);
      } finally {
        setLoading(false);
      }
    };
  }, [setPersons, setLoading, setError]);
};
